import { Button, message, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../../AxiosInstance";
import moment from "moment";
import { amountFormat } from "../../../../utils";
import InvestorView from "./InvestorView";

export default function PartnerReferredPortoflio() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  var [dataSource, setDataSource] = useState([]);
  const [isSendingReferral, setIsSendingReferral] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); // State to handle modal visibility
  const [selectedPortfolio, setSelectedPortfolio] = useState(null); // State to store selected portfolio

  useEffect(() => {
    getTableData(0);
  }, []);

  const getTableData = async (skip) => {
    const url = `/portfolio/investor/referrals?take=10&skip=${skip}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const handleViewPolicies = async (portfolioId) => {
    setLoading(true);
    // Fetch portfolio details by ID
    try {
      const response = await AxiosInstance().get(`/portfolio/${portfolioId}`);
      setSelectedPortfolio(response.data); // Set the selected portfolio data
      console.log(response.data);
      setIsModalVisible(true); // Open the modal
    } catch (error) {
      message.error("Failed to load portfolio data.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const sendRefferal = async (portfolioId, investorId) => {
    setLoading(true);

    const url = `/export/portfolio?portfolioId=${portfolioId}&isSendEmail=true&investorIds=${investorId}`;

    try {
      const resp = await AxiosInstance().get(url);
      let { data } = resp;

      Modal.success({
        content: "Refferal Sent Successfully",
        onOk: () => {
          window.location.reload();
        },
      });
    } catch (err) {
      message.error(err?.response?.data?.message);
      console.error("Error sending referral:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderPolicyDetails = (policies) => {
    const policyColumns = [
      {
        title: "Policy Number",
        dataIndex: "policyNumber",
        key: "policyNumber",
        render: (text, policy) => `${policy?.policy.policyNumber}`,
      },
      {
        title: "Investment Amount",
        dataIndex: "investmentAmount",
        key: "investmentAmount",
        align: "right",
        render: (text, policy) =>
          amountFormat(policy?.policy?.investmentAmount),
      },
      {
        title: "Liquidation Amount",
        dataIndex: "liquidationAmount",
        key: "liquidationAmount",
        align: "right",
        render: (text, policy) =>
          amountFormat(policy?.policy?.liquidationAmount),
      },
      {
        title: "Growth",
        dataIndex: "growthRatio",
        key: "growthRatio",
        render: (text, policy) => `${policy?.policy?.growthRatio}%`,
      },
    ];

    return (
      <Table
        columns={policyColumns}
        dataSource={policies}
        pagination={false}
        scroll={{ x: 800 }}
        rowKey="policyNumber"
      />
    );
  };

  const columns = [
    {
      title: "Refer Date & Time",
      align: "center",
      key: "updatedAt",
      render: (text, policy) =>
        text ? moment(text).format("DD/MM/YYYY") : "N/A",
    },

    {
      title: "Investor Name",
      align: "center",
      render: (text, policy) => (
        <>
          {policy?.investor?.firstName} {policy?.investor?.lastName}
        </>
      ),
    },
    {
      title: "Referred Portfolio",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      render: (text, policy) => policy?.portfolio?.portfolioName,
    },
    {
      title: "Portfolio Date",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      render: (text, policy) =>
        text ? moment(text).format("DD/MM/YYYY") : "N/A",
    },
    {
      title: "Sent Count",
      align: "center",
      dataIndex: "sentCount",
      key: "sentCount",
    },

    {
      title: "Actions",
      align: "center",
      render: (text, policy) => (
        <Button
          disabled={isSendingReferral}
          onClick={async () => {
            setIsSendingReferral(true);
            await sendRefferal(policy.portfolioId, policy.investor.userId);
            setIsSendingReferral(false);
          }}
        >
          ReSend
        </Button>
      ),
    },
    {
      title: "View Policies", // New column for view policies button
      key: "viewPolicies",
      align: "center",
      render: (text, policy) => (
        <Button onClick={() => handleViewPolicies(policy.portfolioId)}>
          View
        </Button>
      ),
    },
  ];

  const change = (data) => {
    getTableData((data - 1) * 10);
  };

  return (
    <div>
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />

      {/* Modal to view policies */}
      <Modal
        title="Portfolio Policies"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1000}
      >
        {selectedPortfolio && selectedPortfolio.PortfolioPolicy
          ? renderPolicyDetails(selectedPortfolio.PortfolioPolicy)
          : "No policies available"}
      </Modal>
    </div>
  );
}
